<div class="bg-dark" style="height:5.5rem;width:100%">&nbsp;</div>
<div class="container">
  <div class="text-center my-5">
    <h1>You have arrived at a page that does not exist. <br />Please try a different page.</h1>
    <h3 class="py-5 mt-5">{{message}}</h3>
  </div>
</div>